import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useColorModeValue,
  Spacer,
  FormControl,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  TableContainer,
  Center,
} from "@chakra-ui/react";
import Select from "react-select";
import "./TableSector.css";
// Custom components
import Card from "components/Card/Card";
import { BsPencil } from "react-icons/bs";
import { BiSliderAlt } from "react-icons/bi";
import { FaHistory } from "react-icons/fa";
// Assets
import { DayOfWeek } from "./DayOfWeek";
import useReceivingSector from "hooks/use-receiving";

import React from "react";
import LoadingComponent from "components/Main/Loading";
import useGeneral from "hooks/use-general";
import ModalUpdateReceivingStore from "./ModalUpdate";
import ModalHistoricInventory from "./ModalHistoric";
import { ParamsDataItem } from "Interfaces/Providers/receivingSector";

const customStyles = {
  option: (provided: any, state: { isSelected: any }) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: state.isSelected ? "black" : "black",
    padding: 20,
  }),
};
const estiloNumberInput = {
  NumberInputStepper: 35,
  /* Adicione outros estilos conforme necessário */
};

// const columns = columnsDataCheck;
export default function ReceivingSector(props: { tableData: any }) {
  const { getData: getDataStore, data: dataStore } = useGeneral();
  const {
    data,
    getData,
    isFirstData,
    clearParams,
    postData,
    getDataStructure,
    dataScruture,
    loading,
    setNewEntry,
    params,
    handleDynamicCreate,
    setIsOpenUpdate,
    isOpenUpdate,
    limits,
    setIsOpenCreate,
    loadingUpdate,
    handleUpdateLimit,
    isOpenCreate,
    handleStore,
    getReceivingStoreUpdate,
  } = useReceivingSector();

  const textColor = useColorModeValue("black", "white");
  const textColorInvert = useColorModeValue("black", "black");
  const isMobile = useBreakpointValue({ base: true, md: false });
  // const [isOpen, setIsOpen] = React.useState(false);
  const diasSemana: Array<keyof ParamsDataItem> = [
    "segunda",
    "terca",
    "quarta",
    "quinta",
    "sexta",
  ];
  const handleClose = () => {
    setIsOpenCreate(false);
    clearParams();
  };
  const handleCloseUpdate = () => {
    setIsOpenUpdate(false);
    setNewEntry(null);
    clearParams();
  };

  const handleSubmit = () => {
    postData(params);
    // handleClose();
  };

  const handleOpen = () => {
    setIsOpenCreate(true);
  };

  const getUpdate = (id: number) => {
    setIsOpenUpdate(true);
    getReceivingStoreUpdate(id);
  };

  React.useEffect(() => {
    if (isFirstData) {
      getDataStructure();
      getData();
    }
  });

  const parseDayOfWeek = (data: any) => {
    return [
      {
        day: "Segunda Feira",
        content: [
          { label: "Ferragem", value: data?.segundaFerragem },
          { label: "Chaparia", value: data?.segundaChaparia },
        ],
      },
      {
        day: "Terca Feira",
        content: [
          { label: "Ferragem", value: data?.tercaFerragem },
          { label: "Chaparia", value: data?.tercaChaparia },
        ],
      },
      {
        day: "Quarta Feira",
        content: [
          { label: "Ferragem", value: data?.quartaFerragem },
          { label: "Chaparia", value: data?.quartaChaparia },
        ],
      },
      {
        day: "Quinta Feira",
        content: [
          { label: "Ferragem", value: data?.quintaFerragem },
          { label: "Chaparia", value: data?.quintaChaparia },
        ],
      },
      {
        day: "Sexta Feira",
        content: [
          { label: "Ferragem", value: data?.sextaFerragem },
          { label: "Chaparia", value: data?.sextaChaparia },
        ],
      },
    ];
  };

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex>
        {"\u00A0"}
        {"\u00A0"}
        <ModalHistoricInventory />
        <Spacer />
      </Flex>
      <Flex px="10px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        ></Text>

        {/* <Menu /> */}
        <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
          <Button colorScheme="green" variant="outline" onClick={handleOpen}>
            Adicionar
          </Button>
        </Stack>
      </Flex>
      <ModalUpdateReceivingStore
        isOpen={isOpenUpdate}
        onClose={handleCloseUpdate}
      />
      <Modal isOpen={isOpenCreate} onClose={handleClose} size="7xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Adicionar
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <Box maxW={480} flex={{ base: "1", md: "0 0 300px" }} pb={6}>
              <Select
                onChange={handleStore}
                name="colors"
                options={dataStore}
                placeholder="Selecione um centro"
                theme={(theme: { colors: any }) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    text: "#6EB680",
                    font: "#6EB680",
                    primary25: "#6EB680",
                    primary: "#6EB680",
                    neutral80: "black",
                    color: "black",
                  },
                })}
                styles={customStyles}
                className="custom-select"
                classNamePrefix="select"
              />
            </Box>
            <Box overflowX="auto">
              <TableContainer>
                <Table size="sm" variant="simple">
                  <Thead>
                    <Tr>
                      <Th></Th>
                      <Th
                        border="1px solid black"
                        colSpan={
                          dataScruture.filter(
                            (x) => x.receivingSectorDescription === "Ferragens"
                          ).length + 1
                        }
                        textAlign="center"
                        fontWeight="bold"
                      >
                        Ferragens
                      </Th>
                      <Th
                        border="1px solid black"
                        colSpan={
                          dataScruture.filter(
                            (x) => x.receivingSectorDescription === "Chaparia"
                          ).length + 1
                        }
                        textAlign="center"
                        fontWeight="bold"
                      >
                        Chaparia
                      </Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Thead>
                    <Tr>
                      <Th></Th>
                      <Th border="1px solid black" fontWeight="bold">
                        Limite Diario
                      </Th>
                      {dataScruture
                        .filter(
                          (x) => x.receivingSectorDescription === "Ferragens"
                        )
                        .map((x) => (
                          <Th
                            border="1px solid black"
                            key={`f-${x.productManagerId}`}
                          >
                            {x.productManagerDescription}
                          </Th>
                        ))}
                      <Th border="1px solid black" fontWeight="bold">
                        Limite Diario
                      </Th>
                      {dataScruture
                        .filter(
                          (x) => x.receivingSectorDescription === "Chaparia"
                        )
                        .map((x) => (
                          <Th
                            border="1px solid black"
                            key={`c-${x.productManagerId}`}
                          >
                            {x.productManagerDescription}
                          </Th>
                        ))}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {(
                      ["segunda", "terca", "quarta", "quinta", "sexta"] as const
                    ).map((day) => (
                      <Tr key={day}>
                        <Td scope="row" textTransform="capitalize">
                          {day[0].toUpperCase() + day.slice(1)}
                        </Td>

                        {/* LIMIT - Ferragens */}
                        <Td border="1px solid black">
                          <FormControl>
                            <NumberInput
                              width="100px"
                              background="yellow.100"
                              min={0}
                              max={10000}
                              value={
                                limits.find(
                                  (l) =>
                                    l.receivingSectorDescription === "Ferragens"
                                )?.[day] ?? 0
                              }
                              onChange={
                                (value) =>
                                  handleUpdateLimit(1, day, Number(value)) // 1 = Ferragens
                              }
                            >
                              <NumberInputField color={textColor} />
                            </NumberInput>
                          </FormControl>
                        </Td>

                        {/* Ferragens */}
                        {dataScruture
                          .filter(
                            (x) => x.receivingSectorDescription === "Ferragens"
                          )
                          .map((x) => (
                            <Td
                              border="1px solid black"
                              key={`f-${x.productManagerId}-${day}`}
                            >
                              <FormControl>
                                <NumberInput
                                  width="100px"
                                  min={0}
                                  max={10000}
                                  value={x[day]}
                                  onChange={(value) =>
                                    handleDynamicCreate(
                                      x.productManagerId,
                                      x.receivingSectorId,
                                      day,
                                      value
                                    )
                                  }
                                >
                                  <NumberInputField color={textColor} />
                                </NumberInput>
                              </FormControl>
                            </Td>
                          ))}

                        {/* LIMIT - Chaparia */}
                        <Td border="1px solid black">
                          <FormControl>
                            <NumberInput
                              width="100px"
                              background="yellow.100"
                              min={0}
                              max={10000}
                              value={
                                limits.find(
                                  (l) =>
                                    l.receivingSectorDescription === "Chaparia"
                                )?.[day] ?? 0
                              }
                              onChange={
                                (value) =>
                                  handleUpdateLimit(2, day, Number(value)) // 2 = Chaparia
                              }
                            >
                              <NumberInputField color={textColor} />
                            </NumberInput>
                          </FormControl>
                        </Td>

                        {/* Chaparia */}
                        {dataScruture
                          .filter(
                            (x) => x.receivingSectorDescription === "Chaparia"
                          )
                          .map((x) => (
                            <Td
                              border="1px solid black"
                              key={`c-${x.productManagerId}-${day}`}
                            >
                              <FormControl>
                                <NumberInput
                                  width="100px"
                                  min={0}
                                  max={10000}
                                  value={x[day]}
                                  onChange={(value) =>
                                    handleDynamicCreate(
                                      x.productManagerId,
                                      x.receivingSectorId,
                                      day,
                                      value
                                    )
                                  }
                                >
                                  <NumberInputField color={textColor} />
                                </NumberInput>
                              </FormControl>
                            </Td>
                          ))}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={handleClose}>
              Fechar
            </Button>
            <Button
              colorScheme="green"
              ml={3}
              isDisabled={dataScruture[0]?.storeId === 0}
              onClick={handleSubmit}
              disabled={loadingUpdate}
            >
              {" "}
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Flex justify="flex-end"></Flex>
      {loading ? (
        <>
          <LoadingComponent spinnerSize="50vh" />
        </>
      ) : (
        <>
          {isMobile ? (
            <Grid
              templateColumns="repeat(auto-fit, minmax(200px, 1fr))"
              gap={4}
              p={4}
            >
              {data.map((item) => (
                <Flex key={item.code} direction="row">
                  <Box
                    borderWidth="3px"
                    borderRadius="md"
                    p={4}
                    boxShadow="base"
                    _hover={{ boxShadow: "xl" }}
                    flex="1"
                  >
                    <Stack spacing={2}>
                      <Box as="strong">
                        <Flex>
                          <Text color="gray.400">Centro: </Text>
                          <Spacer></Spacer>
                          <Text>
                            {item.storeId} - {item.storeDescription}
                          </Text>
                        </Flex>
                      </Box>

                      <hr></hr>
                      <Box>
                        <Box>
                          {parseDayOfWeek(item).map((day, index) => (
                            <>
                              <DayOfWeek
                                key={index}
                                day={day.day}
                                content={day.content}
                              />
                              <hr></hr>
                            </>
                          ))}
                        </Box>
                      </Box>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Flex>
                          <IconButton
                            icon={<BsPencil />}
                            onClick={() => {
                              getUpdate(item.storeId);
                            }}
                            aria-label="Editar"
                            variant="outline"
                            size="sm"
                            colorScheme="teal"
                          />
                        </Flex>
                      </Flex>
                    </Stack>
                  </Box>
                </Flex>
              ))}
            </Grid>
          ) : (
            // Exibir a tabela em versões desktop
            <Box overflowX="auto">
              <Box>
                <TableContainer>
                  <Table
                    className="custom-table"
                    variant="simple"
                    color="gray.500"
                    mb="24px"
                    mt="12px"
                  >
                    <Thead>
                      <Tr>
                        <Th></Th>
                        <Th
                          color={textColorInvert}
                          colSpan={2}
                          textAlign="center"
                          fontWeight="bold"
                        >
                          Segunda-Feira
                        </Th>
                        <Th
                          color={textColorInvert}
                          colSpan={2}
                          textAlign="center"
                          fontWeight="bold"
                        >
                          Terça-Feira
                        </Th>
                        <Th
                          color={textColorInvert}
                          colSpan={2}
                          textAlign="center"
                          fontWeight="bold"
                        >
                          Quarta-Feira
                        </Th>
                        <Th
                          color={textColorInvert}
                          colSpan={2}
                          textAlign="center"
                          fontWeight="bold"
                        >
                          Quinta-Feira
                        </Th>
                        <Th
                          color={textColorInvert}
                          colSpan={2}
                          textAlign="center"
                          fontWeight="bold"
                        >
                          Sexta-Feira
                        </Th>
                        <Th></Th>
                      </Tr>
                    </Thead>
                    <Thead>
                      <Tr>
                        <Th color={textColorInvert}>Centro</Th>
                        <Th color={textColorInvert}> Ferragens</Th>
                        <Th color={textColorInvert}>Chaparia</Th>
                        <Th color={textColorInvert}>Ferragens</Th>
                        <Th color={textColorInvert}>Chaparia</Th>
                        <Th color={textColorInvert}>Ferragens</Th>
                        <Th color={textColorInvert}>Chaparia</Th>
                        <Th color={textColorInvert}>Ferragens</Th>
                        <Th color={textColorInvert}>Chaparia</Th>
                        <Th color={textColorInvert}>Ferragens</Th>
                        <Th color={textColorInvert}>Chaparia</Th>
                        <Th color={textColorInvert}>Ações</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.map((item) => (
                        <Tr>
                          <Td color={textColor} scope="row">
                            {" "}
                            {item.storeId} - {item.storeDescription}
                          </Td>
                          <Td color={textColor} scope="row">
                            {item.segundaFerragem}
                          </Td>
                          <Td color={textColor} textAlign="center">
                            {item.segundaChaparia}
                          </Td>
                          <Td color={textColor} scope="row">
                            {item.tercaFerragem}
                          </Td>
                          <Td color={textColor} textAlign="center">
                            {item.tercaChaparia}
                          </Td>
                          <Td color={textColor} scope="row">
                            {item.quartaFerragem}
                          </Td>
                          <Td color={textColor} textAlign="center">
                            {item.quartaChaparia}
                          </Td>
                          <Td color={textColor} scope="row">
                            {item.quintaFerragem}
                          </Td>
                          <Td color={textColor} textAlign="center">
                            {item.quintaChaparia}
                          </Td>
                          <Td color={textColor} scope="row">
                            {item.sextaFerragem}
                          </Td>
                          <Td color={textColor} textAlign="center">
                            {item.sextaChaparia}
                          </Td>
                          <Td>
                            {" "}
                            <Center>
                              <IconButton
                                onClick={() => {
                                  getUpdate(item.storeId);
                                }}
                                icon={<BsPencil />}
                                aria-label="Editar"
                                variant="outline"
                                size="sm"
                                colorScheme="teal"
                              />
                            </Center>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          )}
        </>
      )}
    </Card>
  );
}
